import { PartialGradeMetrics } from 'app/library/partial-grade/models/partial-grade-metric.model';
import { ICreateEntityFailureActionPayload } from 'app/projects/entity/src/lib/interfaces/create-entity-failure-payload.interface';
import { IFetchEntityFailureActionPayload } from 'app/projects/entity/src/lib/interfaces/fetch-entity-failure-payload.interface';
import { IUpdateEntityFailureActionPayload } from 'app/projects/entity/src/lib/interfaces/update-entity-failure-payload.interface';
import { ICreateGradedUnitFromCourseOfferingActionPayload } from '../interfaces/create-graded-unit-from-course-offering.action.payload.interface';
import { GradedUnit } from '../models/graded-unit.model';

export class SetGradedUnit {
    static readonly type = '[GradedUnit] SetGradedUnit';

    constructor(public payload: GradedUnit) {}
}

export class UnsetGradedUnit {
    static readonly type = '[GradedUnit] UnsetGradedUnit';
}

export class FetchGradedUnit {
    static readonly type = '[GradedUnit] FetchGradedUnit';

    constructor(public payload: string) {}
}

export class FetchGradedUnitSuccess {
    static readonly type = '[GradedUnit] FetchGradedUnitSuccess';

    constructor(public payload: GradedUnit) {}
}

export class FetchGradedUnitFailure {
    static readonly type = '[GradedUnit] FetchGradedUnitFailure';

    constructor(public payload: IFetchEntityFailureActionPayload) {}
}

export class AddGradedUnits {
    static readonly type = '[GradedUnit] AddGradedUnits';

    constructor(public payload: GradedUnit[]) {}
}

export class CreateGradedUnit {
    static readonly type = '[GradedUnit] CreateGradedUnit';

    constructor(public payload: GradedUnit) {}
}

export class CreateGradedUnitSuccess {
    static readonly type = '[GradedUnit] CreateGradedUnitSuccess';

    constructor(public payload: GradedUnit) {}
}

export class CreateGradedUnitFailure {
    static readonly type = '[GradedUnit] CreateGradedUnitFailure';

    constructor(public payload: ICreateEntityFailureActionPayload) {}
}

export class UpdateGradedUnit {
    static readonly type = '[GradedUnit] UpdateGradedUnit';

    constructor(public payload: GradedUnit) {}
}

export class UpdateGradedUnitSuccess {
    static readonly type = '[GradedUnit] UpdateGradedUnitSuccess';

    constructor(public payload: GradedUnit) {}
}

export class UpdateGradedUnitFailure {
    static readonly type = '[GradedUnit] UpdateGradedUnitFailure';

    constructor(public payload: IUpdateEntityFailureActionPayload) {}
}

export class DeleteGradedUnit {
    static readonly type = '[GradedUnit] DeleteGradedUnit';

    constructor(public payload: string) {}
}

export class DeleteGradedUnitSuccess {
    static readonly type = '[GradedUnit] DeleteGradedUnitSuccess';

    constructor(public payload: string) {}
}

export class DeleteGradedUnitFailure {
    static readonly type = '[GradedUnit] DeleteGradedUnitFailure';

    constructor(public payload: string) {}
}

export class SetGradedUnits {
    static readonly type = '[GradedUnit] SetGradedUnits';

    constructor(public payload: GradedUnit[]) {}
}

export class FetchGradedUnitMetrics {
    static readonly type = '[GradedUnit] FetchGradedUnitMetrics';

    constructor(public payload: string) {}
}

export class FetchGradedUnitMetricsSuccess {
    static readonly type = '[GradedUnit] FetchGradedUnitMetricsSuccess';

    constructor(public payload: PartialGradeMetrics) {}
}

export class FetchGradedUnitMetricsFailure {
    static readonly type = '[GradedUnit] FetchGradedUnitMetricsFailure';

    constructor(public payload: IFetchEntityFailureActionPayload) {}
}

export class CreateGradedUnitFromCourseOffering {
    static readonly type = '[GradedUnit] CreateGradedUnitFromCourseOffering';

    constructor(public payload: ICreateGradedUnitFromCourseOfferingActionPayload) {}
}

export class CreateGradedUnitFromCourseOfferingSuccess {
    static readonly type = '[GradedUnit] CreateGradedUnitFromCourseOfferingSuccess';

    constructor(public payload: GradedUnit[]) {}
}

export class CreateGradedUnitFromCourseOfferingFailure {
    static readonly type = '[GradedUnit] CreateGradedUnitFromCourseOfferingFailure';

    constructor(public payload: ICreateEntityFailureActionPayload) {}
}
